export let CalloutColor;

(function (CalloutColor) {
  CalloutColor["HELP"] = "ske-color-green-10";
  CalloutColor["INFO"] = "ske-color-brown-10";
  CalloutColor["ERROR"] = "ske-color-burgundy-10";
  CalloutColor["WARNING"] = "ske-color-brown-10";
  CalloutColor["BASIC"] = "ske-color-white-100";
})(CalloutColor || (CalloutColor = {}));